module.exports = __webpack_public_path__ + "img/huifu.95e4fe0d.png";